import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  max-width: 100%;
  flex: 1 1 auto;
`;
